<template>
  <div class="toggle-box">
    <div class="toggle-box__header" @click="toggleContent">
      <TickIcon class="toggle-box__tick" :border-color="'#FF6841'" />
      <p class="toggle-box__title">
        {{ item.title }}
      </p>
      <ChevronIcon
        v-if="isTablet"
        class="toggle-box__chevron"
        :position="chevronPosition"
      />
    </div>
    <div v-if="showContentCheck" class="toggle-box__content">
      <p class="toggle-box__content__text">
        {{ item.content }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TickIcon from '@/components/icons/TickIcon'
import ChevronIcon from '@/components/icons/ChevronIcon'
export default {
  name: 'ToggleBox',
  components: {
    TickIcon,
    ChevronIcon
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showContent: false
    }
  },
  computed: {
    ...mapGetters(['isTablet']),
    chevronPosition () {
      if (!this.showContent) return 'bottom'
      return ''
    },
    showContentCheck () {
      if (!this.isTablet) {
        return true
      } else {
        return this.showContent
      }
    }
  },
  methods: {
    toggleContent () {
      if (!this.isTablet) return
      this.showContent = !this.showContent
    }
  }
}
</script>
<style lang="scss" scoped>
.toggle-box {
  position: relative;
  width: 100%;
  background-color: $white;
  border-radius: 6px;
  margin-bottom: 12px;

  @media (min-width: $screen-md) {
    width: 496px;
  }

  &__header {
    cursor: pointer;
    display: flex;
    align-items: center;
    height: 44px;
    padding: 0 15px;

    @media (min-width: $screen-md) {
      padding: 10px 20px 0 24px;
      cursor: unset;
    }
  }

  &__title {
    margin: 0;
    font-size: 12px;
    letter-spacing: -0.47px;

     @media (min-width: $screen-md) {
      font-size: 18px;
       letter-spacing: -0.71px;
    }
  }

  &__tick {
    margin-right: 12px;
    height: 11px;
    width: 6px;
    bottom: 0;

    @media (min-width: $screen-md) {
      margin-right: 20px;
      height: 13px;
      width: 6px;
    }
  }

  &__chevron {
    margin-left: auto;
    margin-bottom: 6px;
  }

  &__content {
    padding: 0px 30px 20px 33px;
    text-align: left;

    @media (min-width: $screen-md) {
      padding: 0px 30px 20px 50px;
    }

    &__text {
      margin: 0;
      line-height: 14px;
      font-size: 10px;
      color: $bionic-lightgrey;
      opacity: 0.8;

      @media (min-width: $screen-md) {
      line-height: 20px;
      font-size: 16px;
      letter-spacing: -0.64px;
    }
    }
  }
}
</style>
